import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // モーダル用css
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '@media screen and (min-width:800px)': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: '960px'
        }
      },
      '@media screen and (max-width:800px)': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: '600px'
        }
      },
      '@media screen and (max-width:600px)': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: '450px'
        }
      },
      '@media screen and (max-width:450px)': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: '350px'
        }
      }
    },
    loadingContainer: {
      backgroundColor: '#F5F5F5',
      height: '636px',
      '@media screen and (min-width:800px)': {
        width: '729px'
      },
      '@media screen and (max-width:800px)': {
        width: '600px'
      },
      '@media screen and (max-width:600px)': {
        width: '450px'
      },
      '@media screen and (max-width:450px)': {
        width: '350px'
      }
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
      float: 'right'
    },
    selectBoxContainer: {
      display: 'flex',
      marginRight: 10,
      paddingLeft: 5,
      paddingTop: 10,
      paddingBottom: 10,
      alignItems: 'center'
    },
    selectBox: {
      border: 1,
      borderStyle: 'solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 4,
      overflow: 'hidden',
      paddingLeft: 14,
      height: 34
    },
    selectBoxInRow: {
      backgroundColor: '#FFFFFF',
      fontSize: '0.9em',
      paddingLeft: '5px',
      paddingRight: '5px',
      minWidth: '90px'
    },
    includeChildProcess: {
      paddingLeft: '5px'
    },
    dialogContent: {
      height: '537.5px',
      borderTop: '1px solid #cfcfcf',
      padding: '15px 25px 15px 25px'
    },
    tableContainer: {
      '@media screen and (min-width:600px)': {
        height: '500px'
      },
      '@media screen and (max-width:600px)': {
        height: '400px'
      }
    },
    underLine: { textDecoration: 'underline' },
    firstRowRight: {
      marginLeft: 20
    },
    centerMessage: {
      '@media screen and (min-width:600px)': {
        textAlign: 'center'
      }
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    spaceBetween: {
      justifyContent: 'space-between'
    },
    headerCellLarge: {
      minWidth: 180,
      maxWidth: 180
    },
    headerCellMedium: {
      minWidth: 113,
      maxWidth: 113
    },
    textAlignCenter: {
      textAlign: 'center'
    },
    textAlignRight: {
      textAlign: 'right'
    },
    flexEnd: {
      justifyContent: 'flex-end'
    },
    breakWord: {
      wordBreak: 'break-all'
    },
    gridContainerPadding: {
      marginTop: 25
    },
    listTableButtonContainer: {
      display: 'flex',
      height: 36.5,
      justifyContent: 'center'
    },
    selectName: {
      marginRight: 10,
      fontSize: '14px'
    },
    paddingRight: {
      paddingRight: 20
    },
    constructInput: {
      '@media screen and (min-width:600px)': {
        width: '300px'
      },
      '@media screen and (max-width:600px)': {
        width: '100%'
      }
    },
    createNewFolderIcon: {
      fontSize: '32px',
      color: 'white',
      backgroundColor: '#666666',
      border: '6px solid #666666',
      borderRadius: '4px',
      '&:hover': {
        cursor: 'pointer'
      },
      marginRight: 10
    },
    fullWidthRwd: {
      '@media screen and (max-width:600px)': {
        width: '100%'
      }
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    },
    nowrapWord: {
      whiteSpace: 'nowrap'
    }
  })
);
